import {en} from './en'
import {it} from './it'
const data = {
  en, it
}
export {data};